module.exports = __webpack_public_path__ + "static/media/logo-comprasma.16cce229.png";